<template>
  <div>
    <div v-if="loading" class="media-history__loading"><ds-spinner inline /> Laden…</div>
    <table v-else-if="history.length" class="media-history__table">
      <thead>
        <tr>
          <th>Versie</th>
          <th>Datum</th>
          <th>Geüpload door</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="version in history" :key="version.versionId">
          <td class="media-history__version">{{ version.versionId }}</td>
          <td>{{ formatDate(version.timestamp) }}</td>
          <td>{{ version.uploadedBy }}</td>
          <td>
            <div class="media-history__actions">
              <ds-button
                v-if="version.sasUrl"
                variant="ghost"
                size="sm"
                data-qa="media-history-preview-button"
                @click="openPreview(version)"
              >
                Bekijken
              </ds-button>
              <ds-button
                variant="ghost"
                size="sm"
                data-qa="media-history-restore-button"
                @click="$emit('restore', version.versionId)"
              >
                Herstellen
              </ds-button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else class="media-history__empty">Geen versies gevonden.</div>

    <media-preview-modal
      v-if="previewVersion"
      id="media-version-preview"
      :sas-url="previewVersion.sasUrl"
      :label="previewLabel"
      @close="closePreview"
      @download="downloadVersion"
    />
  </div>
</template>

<script>
import moment from 'moment'
import DsButton from '@/components/ds/atoms/dsButton/DsButton.vue'
import DsSpinner from '@/components/ds/atoms/dsSpinner/DsSpinner.vue'
import MediaPreviewModal from './MediaPreviewModal.vue'

export default {
  name: 'MediaHistorySubTable',
  components: { DsButton, DsSpinner, MediaPreviewModal },
  props: {
    loading: { type: Boolean, default: false },
    history: { type: Array, default: () => [] },
    mediaLabel: { type: String, default: '' },
  },
  data() {
    return {
      previewVersion: null,
    }
  },
  computed: {
    previewLabel() {
      if (!this.previewVersion) return ''
      const date = this.formatDate(this.previewVersion.timestamp)
      return `${this.mediaLabel} — ${date}`
    },
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '-'
      return moment(timestamp).format('DD-MM-YYYY HH:mm')
    },
    openPreview(version) {
      this.previewVersion = version
    },
    closePreview() {
      this.previewVersion = null
    },
    async downloadVersion() {
      const { sasUrl, versionId } = this.previewVersion
      try {
        const response = await fetch(sasUrl)
        const blob = await response.blob()
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = versionId || 'versie'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch {
        window.open(sasUrl, '_blank')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// Layout for the version rows inside a media table expansion row; the buttons
// come from the design system (styles/ds/).

.media-history__loading {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  padding: var(--ds-space-2) 0;
  font-size: var(--ds-font-size-sm);
  color: var(--ds-color-text-muted);
}

.media-history__table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--ds-font-size-sm);
}

.media-history__table th {
  padding: 7px 10px;
  border-bottom: 1px solid var(--ds-color-border);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-align: left;
  color: var(--ds-color-text-subtle);
}

.media-history__table td {
  padding: 8px 10px;
  border-bottom: 1px solid var(--ds-color-border-subtle);
}

.media-history__version {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: $font-family-mono;
  font-size: 12px;
  color: var(--ds-color-text-muted);
}

.media-history__actions {
  display: flex;
  gap: var(--ds-space-2);
}

.media-history__empty {
  padding: var(--ds-space-2) 0;
  font-size: var(--ds-font-size-sm);
  font-style: italic;
  color: var(--ds-color-text-subtle);
}
</style>
